import { ApolloQueryResult } from 'apollo-client/core/types';

import { freelancerEditorQuery, freelancersListUpdateQuery } from '../../graphql/queries/grid/freelancers';
import { mapLangToGdLanguageInput } from '../../mappers/freelancers';
import { LangUtils } from '../../service/Lang/Lang';
import { FreelancerEditorQuery, FreelancersListUpdateQuery } from '../../typings/graphql-grid';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

const LANG = mapLangToGdLanguageInput(LangUtils.getCurrentLang());

export class FreelancerDataProvider extends BaseDataProvider {
    public fetchFreelancersListUpdateData(login: string) {
        return this.createQuery<FreelancersListUpdateQuery>(freelancersListUpdateQuery, { variables: { login } }).then(
            (result: ApolloQueryResult<FreelancersListUpdateQuery>) => result.data
        );
    }

    public fetchInitialFreelancerData(freelancerLogin: string) {
        return this.createQuery<FreelancerEditorQuery>(freelancerEditorQuery, {
            variables: { freelancerLogin, lang: LANG }
        });
    }
}
